import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

export default function Payment({
  client,
  paymentMethods,
  handleInputChange,
  FORM_MODE,
}) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="BankGiroNumber"
          label="Bankgiro"
          disabled={FORM_MODE === "LOCKED"}
          value={client?.BankGiroNumber}
          onChange={(e) => handleInputChange("BankGiroNumber", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="PlusGiroNumber"
          label="Plusgiro"
          disabled={FORM_MODE === "LOCKED"}
          value={client?.PlusGiroNumber}
          onChange={(e) => handleInputChange("PlusGiroNumber", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="VATRegistration"
          label="Momsregistrering"
          disabled={FORM_MODE === "LOCKED"}
          value={client?.VATRegistration}
          onChange={(e) => handleInputChange("VATRegistration", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="BankBICCode"
          label="BANK/BIC-kod"
          disabled={FORM_MODE === "LOCKED"}
          value={client?.BankBICCode}
          onChange={(e) => handleInputChange("BankBICCode", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="BankAccountNumberIBAN"
          label="Bankkontonr/IBAN"
          disabled={FORM_MODE === "LOCKED"}
          value={client?.BankAccountNumberIBAN}
          onChange={(e) =>
            handleInputChange("BankAccountNumberIBAN", e.target.value)
          }
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
    </Grid>
  );
}
